import { AppointmentsService } from "./appointmentsService";
import { AuthService } from "./authService";
import { ClinicsService } from "./clinicsService";
import { DashboardService } from "./dashboardService";
import { EvaluationsService } from "./evaluationsService";
import { InvoicingService } from "./invoicingService";
import { MedicalRecordsService } from "./medicalRecordsService";
import { NotificationsService } from "./notificationsService";
import { PatientPurchasesService } from "./patientPurchasesService";
import { PushService } from "./pushService";
import { PublicBookingService } from "./publicBookingService";
import { PublicTenantService } from "./publicTenantService";
import { ReminderSettingsService } from "./reminderSettingsService";
import { RoomsService } from "./roomsService";
import { ClinicProgramService } from "./clinicProgramService";
import { TherapistProgramService } from "./therapistProgramService";
import { ServiceCatalogService } from "./serviceCatalogService";
import { ServicesService } from "./servicesService";
import { TenantBrandingService } from "./tenantBrandingService";
import { TenantHomeService } from "./tenantHomeService";
import { TenantProfileService } from "./tenantProfileService";
import { TherapistsService } from "./therapistsService";
import { UsersService } from "./usersService";

export const services = {
    appointments: new AppointmentsService(),
    services: new ServicesService(),
    // The Our Services price list, as opposed to `services` above -- the bookable slots.
    serviceCatalog: new ServiceCatalogService(),
    // The clinic's own copy -- what About says about it.
    tenantProfile: new TenantProfileService(),
    // The clinic's front page, for the console tab that writes it. Its own service rather than
    // part of tenantProfile above for the reason that keeps branding out of it too: both PUTs
    // are full replaces, and one page's save must not be able to blank another's.
    tenantHome: new TenantHomeService(),
    // How the clinic looks: its two brand colours and its logo. Deliberately not part of
    // tenantProfile above -- that one's PUT is a full replace and would blank this.
    tenantBranding: new TenantBrandingService(),
    // The same clinic seen from outside: what a visitor with no session gets, resolved from
    // the hostname rather than from a token. Separate from tenantBranding because the
    // audience is different -- anybody at all -- and so the payload has to be.
    publicTenant: new PublicTenantService(),
    /** Online booking without an account. Removable with `components/pages/PublicBooking`. */
    publicBooking: new PublicBookingService(),
    // When the clinic reminds its patients about tomorrow. Its own service rather than part
    // of tenantBranding: that is read on every app boot, this by one admin tab.
    reminderSettings: new ReminderSettingsService(),

    /** The days and hours the clinic is open: read by the whole clinic, written by its admin. */
    clinicProgram: new ClinicProgramService(),

    /**
     * The days and hours one therapist is available, inside the clinic's own. Read by the whole
     * clinic -- the booking screen needs it to tell a day off from a full one -- and written
     * only by the therapist it belongs to.
     */
    therapistProgram: new TherapistProgramService(),

    /**
     * How many treatment rooms of each kind the clinic has, and which services need one.
     * Administrator only: everybody else sees what rooms do -- the hours left -- through
     * `appointments.getEmptySlots`, never the rooms.
     */
    rooms: new RoomsService(),
    // How the clinic invoices what it sells, and every invoice it has emitted. One service
    // for both halves because they share a provider: the settings say which one, and an
    // invoice is what that one produced.
    invoicing: new InvoicingService(),
    /**
     * A patient's record as one list -- evaluations and uploaded documents together -- and
     * the uploaded half itself. Evaluations are still opened through `evaluations`.
     */
    medicalRecords: new MedicalRecordsService(),
    notifications: new NotificationsService(),
    push: new PushService(),
    therapists: new TherapistsService(),
    clinics: new ClinicsService(),
    users: new UsersService(),
    evaluations: new EvaluationsService(),
    // What patients bought, as opposed to `services` above -- what the clinic offers.
    patientPurchases: new PatientPurchasesService(),
    // The clinic admin's read of all of the above at once: income and caseload.
    dashboard: new DashboardService(),
    authService: new AuthService()
};